import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import {
  FormHeader, Desc, SmallDesc, TextInput, Button, HelpBlock,
} from '../common/styles';
import Email from '../../shared/sign-up/email';
import { useForm } from '../../../shared/form-validator-hook';
import { usePostForgotPassword } from '../../../services/auth-service';
import PasswordRecoveryContext from './context';

const Container = styled.div`
  background-color: ${props => props.theme.bodyBackgroundColor};
  border-radius: ${props => (props.theme.isMobile ? '4px' : '0')};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${props => (props.theme.isMobile ? '92%' : '33vw')};
  margin-top: ${props => (props.theme.isMobile ? '20px' : '0px')};
  ${props => (props.theme.isMobile ? `
    padding: 35px 15px 15px 15px;
    border-radius: 4px;
    border: 1px solid ${props.theme.secondaryColor30Transparent};
    justify-content: flex-start;
  ` : `
    max-width: 480px;
    justify-content: center;
    padding: 40px;
  `)}

  > ${Desc} {
    margin-top: 15px;
  }

  > ${SmallDesc} {
    margin-top: ${props => (props.theme.isMobile ? '73px' : '117px')};
    margin-bottom: 50px;
  }

  > ${TextInput} {
    margin-top: 34px;
    width: 100%;
  }

  > ${Button} {
    margin-top: 34px;
    width: 100%;
  }
`;

const getForgotPasswordError = error => {
  if (_.get(error, 'response.status') === 422) {
    return `Email ${_.get(error, 'response.data.errors.email', [])[0]}.`;
  }
  return null;
};

export default function Form() {
  const { dispatch } = React.useContext(PasswordRecoveryContext);

  const {
    values, useInput, errors, validateForm,
  } = useForm({ email: '' }, { lazy: true });

  const [{ response, error }, forgotPassword] = usePostForgotPassword();

  const [forgotPasswordError, setForgotPasswordError] = React.useState(null);

  React.useEffect(() => {
    const err = getForgotPasswordError(error);

    if (err) {
      setForgotPasswordError(err);
    }
  }, [response, error]);

  React.useEffect(() => {
    setForgotPasswordError(null);
  }, [values]);

  function submit(e) {
    e && e.preventDefault();

    if (validateForm()) {
      forgotPassword(values).then(() => dispatch({ type: 'setEmail', payload: values.email }));
    }
  }

  return (
    <Container>
      <FormHeader>
        Having trouble signing in?
      </FormHeader>
      <Desc>
        Enter your email address below and we’ll send you an email with your instructions.
      </Desc>
      <Email Field={TextInput} Err={HelpBlock} useInput={useInput} errors={errors} focus />
      {forgotPasswordError && <HelpBlock data-error="show">{forgotPasswordError}</HelpBlock>}
      <Button onClick={submit}>Send my instructions</Button>
      <SmallDesc>
        Don’t have a Livewire account?&nbsp;
        <a href="/sign_up">
          Register free today
        </a>
      </SmallDesc>
    </Container>
  );
}
